import {
  forwardRef,
  IconButton,
  IconButtonProps,
  useColorModeValue
} from "@chakra-ui/react";

export const IconButtonGray = forwardRef<IconButtonProps, "button">(
  (props, ref) => {
    const containerColor = useColorModeValue("gray.500", "gray.400");

    return <IconButton {...props} ref={ref} color={containerColor} />;
  }
);
